<template>
  <footer>
    <div class="top">
      <div class="flexB">
        <div class="left">
          <img class="logo" src="@/assets/images/logo_white.svg" alt="로고" />
          <div class="flex store">
            <a
              href="https://apps.apple.com/kr/app/talktalktalk/id6745210474"
              target="_blank"
            >
              <img
                src="@/assets/images/store/appStore_white.png"
                alt="앱스토어 바로가기"
            /></a>
            <a
              href="https://play.google.com/store/apps/details?id=kr.co.batoncompany.TalkTalkTalk&hl=ko"
            >
              <img
                src="@/assets/images/store/googlePlay_white.png"
                alt="구글플레이스토어 바로가기"
            /></a>
          </div>
        </div>
        <div class="right">
          <div class="link">
            <ul>
              <li><button @click="changeLanguage('ko')">한국어</button></li>
              <li><button @click="changeLanguage('en')">English</button></li>
              <!-- <li><button @click="changeLanguage('es')">Español</button></li>
              <li>
                <button @click="changeLanguage('cn')">中文 – 繁體</button>
              </li> -->
            </ul>
            <ul>
              <li>
                <router-link to="/terms">{{ $t("term") }}</router-link>
              </li>
              <li>
                <router-link to="/privacy">{{ $t("privacy") }}</router-link>
              </li>
              <li><router-link to="/faq">FAQ</router-link></li>
              <li><router-link to="/terms">iOS</router-link></li>
              <li><router-link to="/terms">Android</router-link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="flexB">
        <div class="left">
          <!-- <p class="fwm">주식회사 바톤컴퍼니</p> -->
          <ul class="info">
            <li>{{ $t("representative") }}</li>
            <li>{{ $t("contact") }}</li>
            <li>{{ $t("email") }}</li>
            <li>{{ $t("businessRegistrationNumber") }}</li>
            <li>{{ $t("address") }}</li>
          </ul>
        </div>
        <div class="right">
          <p class="copyright">
            Copyright &copy; BatonCompany. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      Cookies.set("language", lang, { expires: 365 });

      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>
